<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-fm"><a href="#/006_Acknowledgments#fm-1"><em>Acknowledgments</em></a></p>
<p class="toc-fm"><a href="#/007_Abbreviations#fm-2"><em>List of Abbreviations</em></a></p>
<p class="toc-fm1"><a href="#/008_Introduction#fm-3">Introduction: Inventing the “Divine Self”<br/><em>Where We Are Headed</em></a></p>
<p class="toc-chap"><a href="#/009_Chapter01#ch-1">1. <span class="toc1">Survivor to Shaman<br/><em>Discovering the Divine Self</em></span></a></p>
<p class="toc-chap"><span href="#/010_Chapter02#ch-2" title="Link target outside of Sample">2. <span class="toc1">Dancing for Dionysus<br/><em>New Myths for the Utopian Stage</em></span></span></p>
<p class="toc-chap"><span href="#/011_Chapter03#ch-3" title="Link target outside of Sample">3. <span class="toc1">Shaman to Sage<br/><em>Religion of the One</em></span></span></p>
<p class="toc-chap"><span href="#/012_Chapter04#ch-4" title="Link target outside of Sample">4. <span class="toc1">“The True Mystics” <br/><em>Orpheus as Plato’s Muse</em></span></span></p>
<p class="toc-chap"><span href="#/013_Chapter05#ch-5" title="Link target outside of Sample">5. <span class="toc1">“The Foes! The Foes!” <br/><em>Soul Saving in Alexandria</em></span></span></p>
<p class="toc-chap"><span href="#/014_Chapter06#ch-6" title="Link target outside of Sample">6. <span class="toc1">Hermes Trismegistus<br/><em>The Cult without Temples</em></span></span></p>
<p class="toc-chap"><span href="#/015_Chapter07#ch-7" title="Link target outside of Sample">7. <span class="toc1">Savior <em class="italic">of</em> or <em class="italic">from</em> the World? <br/><em>Christianity and Gnosis</em></span></span></p>
<p class="toc-chap"><span href="#/016_Chapter08#ch-8" title="Link target outside of Sample">8. <span class="toc1">Orphic Exegesis<br/><em>The Eternal Gospel</em></span></span></p>
<p class="toc-chap"><span href="#/017_Chapter09#ch-9" title="Link target outside of Sample">9. <span class="toc1">A Christian Reconstruction of Late Neoplatonism<br/><em>St. Paul’s Philosopher-Convert</em></span></span></p>
<p class="toc-chap1"><span href="#/018_Chapter10#ch-10" title="Link target outside of Sample">10. <span class="toc1">Cosmotheism as Philosophical Religion<br/><em>Eriugena’s Dionysius</em></span></span></p>
<p class="toc-chap1"><span href="#/019_Chapter11#ch-11" title="Link target outside of Sample">11. <span class="toc1">Prophetic Gnosis<br/><em>Dreaming of Utopia</em></span></span></p>
<p class="toc-bm"><span href="#/020_WorksCited#bm-1" title="Link target outside of Sample"><em>Works Cited</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?5dda8596